module.exports = __webpack_public_path__ + "static/special-needs-planning-hero-desktop.9ffc2034.webp";